module.exports = __webpack_public_path__ + "static/media/blur_job_category_small.1001c5fb.jpg";